<div class="layers" id="layers">
  <div>
    <ul>
      <li *ngIf="reference" [ngClass]="{'active-eye': reference.visible, 'selected': selected == 'reference'}">
        <em><span class="mobile-h">File 01: </span>REFERENCE</em>
        <figure>
          <a (click)="select('reference')">
            <strong></strong>
            <img [src]="reference.url"  />
          </a>
        </figure>
      </li>
      <li *ngIf="target" [ngClass]="{'active-eye': target.visible, 'selected': selected == 'target'}">
        <em><span class="mobile-h">File 02: </span>TARGET</em>
        <figure>
          <a (click)="select('target')">
            <strong></strong>
            <img [src]="target.url" />
          </a>
        </figure>
      </li>

      <!-- compared -->
      <li *ngIf="compared" [ngClass]="{'active-eye': compared.visible, 'selected': selected == 'compared'}">
        <em><span class="mobile-h">File 03: </span>COMPARED</em>
        <figure>
          <a (click)="select('compared')">
            <strong></strong>
            <img [src]="compared.url" />
          </a>
        </figure>
      </li>

    </ul>
  </div>
  <div *ngIf="selected == 'reference'" class="hidden reference-tools">
    <a (click)="select('')" class="close-hidden"><em></em></a>
    <h3>REFERENCE TOOLS</h3>
    <div>
        <core-helpers-forms-select
            [label]="'Opacity:'"
            [options]="opacityOptions.reference"
            (select)="opacitySelect('reference', $event)"
        ></core-helpers-forms-select>
    </div>
    <!-- <fieldset>
      <button *ngIf="controlBtn.reference.active" (click)="onRegisterLayer()">{{controlBtn.reference.text}}</button>
    </fieldset> -->
  </div>

  <div *ngIf="selected == 'target'" class="hidden target-tools">
    <a (click)="selected = ''"  class="close-hidden"><em></em></a>
    <h3>TARGET TOOLS</h3>
    <div>
        <core-helpers-forms-select
            [label]="'Opacity:'"
            [options]="opacityOptions.target"
            (select)="opacitySelect('target', $event)"
        ></core-helpers-forms-select>
    </div>
    <!-- <fieldset>
      <button *ngIf="controlBtn.target.active" (click)="onRegisterLayer()">{{controlBtn.target.text}}</button>
    </fieldset> -->
  </div>

  <div *ngIf="selected == 'compared'" class="hidden compared-tools">
    <a (click)="select('')" class="close-hidden"><em></em></a>
    <h3>COMPARED LAYERS TOOLS</h3>
    <div>
        <core-helpers-forms-select
            [label]="'Opacity:'"
            [options]="opacityOptions.compared"
            (select)="opacitySelect('compared', $event)"
        ></core-helpers-forms-select>
    </div>
  </div>

</div>
